import { Address } from "./address";

export class BaseForm {
    id: string = "";
    form_id: number = 0;
    name: string = "";
    description: string = "";
    event_address: Address = {} as Address;
}
